const featureFlags = {
  enableEventsDeletion: true,
};

export default featureFlags;
